import React, { FC } from 'react';
import { Switch } from 'react-router-dom';
import { Route } from 'react-router';

import Error404 from './errors/404';
import Faq from '../components/help/faq';
import Feedback from '../components/help/feedback';

const HelpPage: FC = () => {
  return (
    <Switch>
      <Route exact path="/help/faq" component={Faq} />
      <Route exact path="/help/feedback" component={Feedback} />
      <Route path="*" component={Error404} />
    </Switch>
  );
};

export default HelpPage;
